import { getMessages } from '../../../../../../store/constants';

export const SNACKBAR_INVITE_SUCCESS_ID = 'SNACKBAR_INVITE_SUCCESS_ID';
export const MESSAGE_SUCCESS_SINGULAR = getMessages().getText('invite.success.singular');
export const MESSAGE_SUCCESS_PLURAL = getMessages().getText('invite.success.plural');
